import React, { Component } from "react";

const SeatNav = (props) => {
  let data = props ? props.data : "";
  return (
    <nav className="navbar navbar-expand-sm navbar-dark bg-dark">
      <div className="collapse navbar-collapse">
        <a className="navbar-brand">
          <i
            className="fa fa-chevron-left mr-3 "
            aria-hidden="true"
            style={{ height: "2px" }}
            onClick={() => props.onBack()}
          ></i>

          <span style={{ fontSize: "25px" }}>{data ? data.title : ""}</span>
          <br />
          <span className="ml-3" style={{ fontSize: "15px" }}>
            {props.rowdata ? props.rowdata.name : ""}
          </span>
        </a>
      </div>
      {props.page === "Seats" ? (
        <span className="text-white m-1">{props.ticket} Tickets</span>
      ) : (
        ""
      )}
      <i
        className="fa fa-times text-white"
        style={{ fontSize: "12px" }}
        aria-hidden="trues"
        onClick={() => props.onBack()}
      ></i>
    </nav>
  );
};

export default SeatNav;
